/** Uber Direct `dropoff_notes` field limit (observed API failures above ~280 chars). */
export const UBER_DROPOFF_NOTES_MAX_LENGTH = 280;
export function getUberDropoffNotesLength(notes) {
    return notes?.length ?? 0;
}
export function isUberDropoffNotesTooLong(notes) {
    return getUberDropoffNotesLength(notes) > UBER_DROPOFF_NOTES_MAX_LENGTH;
}
/** True for Uber Direct v1 and v2 orders (`delivery_provider` is always `uber`). */
export function isUberDeliveryOrder(service, deliveryProvider) {
    return service === 'delivery' && deliveryProvider === 'uber';
}
export function isUberOrderConfig(config) {
    if (!config) {
        return false;
    }
    return isUberDeliveryOrder(config.service, config.delivery_provider);
}
/** True when Uber delivery notes are at or over the limit (checkout must not proceed). */
export function blocksCheckoutDueToUberNotes(service, deliveryProvider, notes) {
    return (isUberDeliveryOrder(service, deliveryProvider) &&
        getUberDropoffNotesLength(notes) >= UBER_DROPOFF_NOTES_MAX_LENGTH);
}
export function clampUberDropoffNotes(notes) {
    if (notes.length <= UBER_DROPOFF_NOTES_MAX_LENGTH) {
        return notes;
    }
    return notes.slice(0, UBER_DROPOFF_NOTES_MAX_LENGTH);
}
/**
 * Truncates delivery notes to Uber's max length before create-delivery API calls.
 */
export function prepareUberDropoffNotes(notes) {
    if (!notes) {
        return undefined;
    }
    if (notes.length <= UBER_DROPOFF_NOTES_MAX_LENGTH) {
        return notes;
    }
    return notes.slice(0, UBER_DROPOFF_NOTES_MAX_LENGTH);
}
//# sourceMappingURL=dropoffNotes.js.map